function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 11.46v2.57c0 .18-.1.34-.25.43l-2 1.15c-.15.09-.34.09-.5 0l-2-1.15a.484.484 0 01-.25-.43v-2.28c0-.18.1-.34.25-.43l2-1.15c.15-.09.35-.09.5 0l1 .58 1.25.71zm8 .29v2.28c0 .18-.1.34-.25.43l-2 1.15c-.15.09-.34.09-.5 0l-2-1.15a.484.484 0 01-.25-.43v-2.57l1.25-.71 1-.58c.15-.09.34-.09.5 0l2 1.15c.15.08.25.25.25.43z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.75 9.62v1.13l-1.25.71v1.73l-1.25.72c-.15.09-.34.09-.5 0l-1.25-.72v-1.73l-1.25-.71V9.62c0-.18.1-.34.25-.43l2.25-1.29c.15-.09.34-.09.5 0l2.25 1.29c.15.08.25.25.25.43z"
})));